import { CaseAdmin, CaseDocumentAdmin } from "pwapi";

import DocumentsTable from "../documentsTable/DocumentsTable";

const Documents = ({
  adminCase,
  documents,
  setPreviewDocumentId,
}: {
  adminCase?: CaseAdmin;
  documents: CaseDocumentAdmin[];
  setPreviewDocumentId: Function;
}) => {
  return (
    <div className="panelContainer panelContainer--gap">
      <DocumentsTable
        documents={documents}
        setPreviewDocumentId={setPreviewDocumentId}
        adminCase={adminCase}
      />
    </div>
  );
};

export default Documents;
